import React, { useEffect, useState } from 'react';
import {
  FormSelect,
  FilterWidget,
  MasterDetailForm,
  FormSubmitButton,
  Button,
  FormInput,
  FormDatePicker,
  usePromise,
  OptionProps,
  FormNumber,
} from '@digital/ui';
import { useActions } from 'easy-peasy';
import { getAllOptionsStatusModuloEconomicoRequisitado } from '@app/api/statusModuloEconmicoContratado';
import { getAllStatusRequisicaoCompraSeqOptions } from '@app/api/status';
import ptBr from '@app/i18n/ptBR/index';

const FiltrosPcs = (props: { onSearch: Function; atualizarTela: Function }) => {
  var trocarDeValor = [true, false];
  const { onSearch, atualizarTela } = props;
  const toggleMenuFullCollapse = useActions(state => state.ui.toggleMenuFullCollapse);
  const [statusModuloEconomicoRequisitado] = usePromise(
    getAllOptionsStatusModuloEconomicoRequisitado,
    [],
    [] as OptionProps[],
  );
  const [statusRequisicaoCompraSeqOptions] = usePromise(
    getAllStatusRequisicaoCompraSeqOptions,
    [],
    [] as OptionProps[],
  );

  const [valorInicial, setValorInicial] = useState<any>({} as any);
  const [trocarValor, setTrocarValor] = useState<boolean>(trocarDeValor.reverse()[0]);

  const limparFormulario = () => {
    const trocarValorTeste = trocarValor;
    setTrocarValor(!trocarValor);
    setValorInicial({
      codigoCentroCustoFormulario: '',
      nomeCentroCustoFormulario: '',
      statusModuloEconomicoRequisitadoFormulario: [],
      codigoAgrupadorFormulario: '',
      contaContabilFormulario: '',
      numeroRequisicaoCompraFormulario: '',
      numeroItemRequisicaoCompraFormulario: '',
      statusRequisicaoCompraFormulario: [],
      dataRequisicaoCompraFormulario: '',

      //---------------------------------------------------------------------------------------------------------------------

      codigoProjetoFormulario: ``,
      nomeProjetoFormulario: '',
      codigoOrdemInvestimentoFormulario: '',
      nomeOrdemInvestimentoFormulario: '',
      numeroOrdemInvestimentoFormulario: '',

      numeroOrdemCompraFormulario: '',
      dataEmissaoOrdemCompraFormulario: '',

      numeroPedidoCompraFormulario: '',
      tipoPedidoCompraFormulario: '',

      nomeFornecedorPedidoCompraFormulario: '',
      numeroContratoPcsFormulario: '',
      mudarValor: trocarValorTeste,
    });
    atualizarTela();
  };

  useEffect(() => {
    // toggleMenuFullCollapse(); //Collapse menu on load page
  }, []);

  return (
    <MasterDetailForm key="filtroPesquisa" initialValues={valorInicial} onSubmit={onSearch}>
      <FilterWidget
        title="FILTROS DE PESQUISA"
        actions={[
          <Button
            type="link"
            title="Limpar"
            onClick={() => {
              limparFormulario();
            }}
          />,
          <FormSubmitButton icon={'commons-search'}>Pesquisar</FormSubmitButton>,
        ]}>
        <div className="ant-row">
        <FormInput
            name="numeroCentroCustoFormulario"
            id="numeroCentroCustoFormulario"
            label={ptBr.numCentroDeCusto}
            span={3}
            allowClear
          />

          <FormInput
            name="codigoCentroCustoFormulario"
            id="codigoCentroCustoFormulario"
            label={ptBr.codCentroDeCusto}
            span={3}
            allowClear
          />
          <FormInput
            name="nomeCentroCustoFormulario"
            id="nomeCentroCustoFormulario"
            label={ptBr.nomeCentroDeCusto}
            span={3}
            allowClear
          />

          <FormSelect
            showSearch
            optionFilterProp="children"
            filterOption={(input, item) => {
              return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
            }}
            mode="multiple"
            name="statusModuloEconomicoRequisitadoFormulario"
            id="statusModuloEconomicoRequisitadoFormulario"
            label={ptBr.statusCadastrado}
            options={statusModuloEconomicoRequisitado}
            span={3}
            allowClear
          />
        </div>

        <div className="ant-row">
          <FormInput
            name="acronimoAgrupadorFormulario"
            id="acronimoAgrupadorFormulario"
            label={ptBr.acronimoAgrupador}
            span={3}
            allowClear
          />

          <FormInput
            name="codigoAgrupadorFormulario"
            id="codigoAgrupadorFormulario"
            label={ptBr.codAgrupador}
            span={3}
            allowClear
          />

          <FormInput
            name="contaContabilFormulario"
            id="contaContabilFormulario"
            label={ptBr.contaContabil}
            span={3}
            allowClear
          />

          <FormSelect
            showSearch
            optionFilterProp="children"
            filterOption={(input, item) => {
              return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
            }}
            mode="multiple"
            name="statusRequisicaoCompraFormulario"
            id="statusRequisicaoCompraFormulario"
            label={ptBr.statusRequisicaoCompra}
            options={statusRequisicaoCompraSeqOptions}
            span={3}
            allowClear
          />
        </div>

        <div className="ant-row">
          <FormNumber
            name="numeroRequisicaoCompraFormulario"
            id="numeroRequisicaoCompraFormulario"
            label={ptBr.numeroRequisicaoDeCompra}
            span={3}
          />
          <FormNumber
            name="numeroItemRequisicaoCompraFormulario"
            id="numeroItemRequisicaoCompraFormulario"
            label={ptBr.itemRequisicaoCompra}
            span={3}
          />

          <FormDatePicker
            name="dataRequisicaoCompraFormulario"
            id="dataRequisicaoCompraFormulario"
            label={ptBr.dataRequisicaoCompra}
            span={3}
            format="DD/MM/YYYY"
            allowClear
          />
        </div>
      </FilterWidget>
    </MasterDetailForm>
  );
};

export default FiltrosPcs;
